import { ClusterKey, SearchClusterMap } from 'src/types/search/common/clusters';

export const hasClusterGroups = <F extends ClusterKey>(cluster: SearchClusterMap[F]) =>
    Boolean(cluster) && Object.values(cluster?.groups || {}).length > 0;
